var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-details"},[_c('Navbar',{attrs:{"title":"订单详情","isHandleBack":true,"isSpecialBack":true},on:{"goBack":_vm.handleBack}}),_c('div',{staticClass:"content"},[_c('order-details-card'),_c('order-details-account'),_c('order-details-payment-plan',{attrs:{"stepList":_vm.stepList,"currentStep":_vm.currentStep}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }